export const indexTariff: TariffData = {
    title: 'Фиксированные тарифы',
    subscriptionTime: [
        {
            label: '1 месяц',
            value: 0,
            discount: ''
        },
        {
            label: '3 месяца',
            value: 1,
            discount: '-10%'
        },
        {
            label: '6 месяцев',
            value: 2,
            discount: '-20%'
        },
        {
            label: '12 месяцев',
            value: 3,
            discount: '-30%'
        }
    ],
    tariffsList: [
        {
            title: 'Basic',
            subtitle: 'Идеальный старт',
            description: '<span>Базовый&nbsp;тарифа</span> лучшее&nbsp;вложение для старта проекта',
            price: {
                fullPrice: '10 500',
                discountPrice: [0, 8500, 7500, 6500]
            },
            benefits: [
                'Доступ к 5 инструментам',
                '10 запросов в месяц'
            ],
            primary: false,
        },
        {
            title: 'Standard',
            subtitle: '',
            description: '<span>Стандартный&nbsp;тариф</span> оптимальное&nbsp;решение для малого бизнеса',
            price: {
                fullPrice: '16 500',
                discountPrice: [0, 14850, 13500, 12500]
            },
            benefits: [
                'Доступ к 5 инструментам',
                '10 запросов в месяц'
            ],
            primary: false,
        },
        {
            title: 'Pro',
            subtitle: 'Выгодная цена',
            description: '<span>Тариф&nbsp;Pro</span> лучшее&nbsp;вложение для старта проекта',
            price: {
                fullPrice: '28 500',
                discountPrice: [0, 27500, 27000, 26500]
            },
            benefits: [
                'Доступ к основным инструментам',
                '160 запросов в месяц',
                'Личный менеджер'
            ],
            primary: true,
        },
        {
            title: 'MAX',
            subtitle: '',
            description: '<span>Максимум возможностей</span> неограниченные возможности&nbsp;для роста',
            price: {
                fullPrice: '75 000',
                discountPrice: [0, 74500, 73500, 60500]
            },
            benefits: [
                'Доступ к 5 инструментам',
                '10 запросов в месяц'
            ],
            primary: false,
        },
    ]
}

export interface TabItem {
    label: string
    value: string | number
}

export type TariffTabItem = TabItem & { discount: string }

interface TariffItemPrice {
    fullPrice: string
    discountPrice: number[]
}

export interface TariffItem {
    title: string
    subtitle: string
    description: string
    price: TariffItemPrice
    benefits: string[]
    primary: boolean
}

export interface TariffData {
    title: string
    subscriptionTime: TariffTabItem[]
    tariffsList: TariffItem[]
}
